export default "__VITE_ASSET__BaxObyb3__"